/**
 * @file routes/_app/settings/document-library.tsx
 * @description 「文件資料庫」維護頁路由（序180/181）。
 */
import { createFileRoute } from '@tanstack/react-router';
import { DocumentLibraryPage } from '@/components/settings/DocumentLibraryPage';

export const Route = createFileRoute('/_app/settings/document-library')({
  component: DocumentLibraryPage,
});
